<template>
    <div>
        <!-- Seção do idoso -->
        <div v-if="isIdoso">
            <div class="card mb-0 shadow">
                <div class="card-body">
                    <div class="tab-content">
                        <div class="animate__animated animate__fadeIn">
                            <load
                                mode="table"
                                message="Carregando termo de compromisso"
                                v-if="loading"
                            />
                            <div class="row px-2 border mb-3" v-else>
                                <div id="boxPrint" class="col-12 mb-3" contenteditable>
                                    <print-header
                                        class="d-flex justify-content-center"
                                    />
                                    <div id="boxContent" v-html="text_edit"></div>
                                </div>
                            </div>
                            <div
                                class="row px-0 d-flex justify-content-end"
                                v-if="loading == false"
                            >
                                <button
                                    class="btn btn-primary"
                                    :title="$t('Visualizar e Imprimir')"
                                    @click="print"
                                >
                                    <i class="mdi mdi-printer mdi-18px" />
                                </button>
                                <b-button class="btn btn-default" @click="redefinir">
                                    <i class="mdi mdi-autorenew mdi-18px" />
                                </b-button>
                                <button
                                    class="btn btn-success btn-submit"
                                    data-style="zoom-in"
                                    type="submit"
                                    @click="submit"
                                >
                                    <i class="mdi mdi-content-save" />
                                    {{ $t("Salvar") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Seção dos familiares -->
        <div v-else>
            <div class="row">
                <div class="col-12">

                    <h3>Pessoas Vinculadas ao Acolhimento: </h3>

                    <b-table :items="todasPessoas" :fields="['nome', 'idade', 'parentesco']" small responsive>
                        <template #cell(nome)="row">
                            <a href="#" @click.prevent="selecionarPessoa(row.item)">
                                {{ row.item.nome }}
                            </a>
                        </template>
                    </b-table>

                    <div v-if="pessoaSelecionada">

                        <br><br>

                        <h3> Termo de Compromisso de: {{ pessoaSelecionada.nome }}</h3>

                        <div class="card mb-0 shadow">
                            <div class="card-body">
                                <div class="tab-content">
                                    <div class="animate__animated animate__fadeIn">
                                        <load
                                            mode="table"
                                            message="Carregando termo de compromisso"
                                            v-if="loading"
                                        />
                                        <div class="row px-2 border mb-3" v-else>
                                            <div id="boxPrint" class="col-12 mb-3" contenteditable>
                                                <print-header
                                                    class="d-flex justify-content-center"
                                                />
                                                <div id="boxContent" v-html="caractTermoSelecionada?.texto || ''"></div>
                                            </div>
                                        </div>
                                        <div
                                            class="row px-0 d-flex justify-content-end"
                                            v-if="loading == false"
                                        >
                                            <button
                                                class="btn btn-primary"
                                                :title="$t('Visualizar e Imprimir')"
                                                @click="print"
                                            >
                                                <i class="mdi mdi-printer mdi-18px" />
                                            </button>
                                            <b-button class="btn btn-default" @click="redefinir">
                                                <i class="mdi mdi-autorenew mdi-18px" />
                                            </b-button>
                                            <button
                                                class="btn btn-success btn-submit"
                                                data-style="zoom-in"
                                                type="submit"
                                                @click="submit"
                                            >
                                                <i class="mdi mdi-content-save" />
                                                {{ $t("Salvar") }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Editor from "@tinymce/tinymce-vue";
export default {
    props: ["item"],
    components: {
        editor: Editor,
    },
    data() {
        return {
            termo: {
                idoso: {
                    texto: null,
                },
                pessoasVinculadas: []
            },
            caractTermoSelecionada: null,
            pessoaReferencia: [],
            pessoaSelecionada: null,

            observacoes: "",
            app_cidade: this.$store.state.settings.app_cidade,
            loading: true,
            text_edit: "",
            text_default:
                '<h2 style="text-align: center;">Termo de Compromisso</h2>\n<p style="text-align: justify;">Eu, <strong><span id="socioeducando">______________________________________</span> </strong>, declaro ter sido devidamente orientado (a) sobre as <br />responsabilidades no cumprimento do Plano de Objetivos e Metas a mim estabelecido, comprometendo-me a:</p>\n<p>I. comparecer aos Atendimentos;&nbsp;<br />II. participar dos grupos, servi&ccedil;os e programas sugeridos pela equipe t&eacute;cnica;&nbsp;<br />III. comprometimento com os objetivos e metas estabelecidos;<br />IV. participar do processo de constru&ccedil;&atilde;o e avalia&ccedil;&atilde;o do plano ____________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________</p>\n<p style="text-align: justify;">Eu, <span id="responsavel">____________________________________________</span>, enquanto respons&aacute;vel pela crian&ccedil;a ou adolescente supracitado, <br />comprometo-me a colaborar no cumprimento dos objetivos e metas estabelecidos neste plano individual de Atendimento (PIA).</p>\n<p>&nbsp;</p>\n<p style="float: right;"><span id="cidade">São Paulo</span>,<span id="data">_____ de ________________ de 2021</span><br /><br /></p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n<p><strong>Observa&ccedil;&otilde;es Gerais:</strong></p>\n<p>___________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________</p>\n<p><strong>ASSINATURAS DE COMPROMISSO:</strong></p>\n<p>&nbsp;</p>\n<p style="text-align: center;">___________________________________________________________________</p>\n<p style="text-align: center;"><strong>USU&Aacute;RIO</strong></p>\n<p>&nbsp;</p>\n<p style="text-align: center;">___________________________________________________________________</p>\n<p style="text-align: center;"><strong>RESPONS&Aacute;VEL</strong></p>\n<p>&nbsp;</p>\n<p style="text-align: center;">___________________________________________________________________</p>\n<p style="text-align: center;"><strong>T&Eacute;CNICO DE REFER&Ecirc;NCIA DO SERVI&Ccedil;O DE ACOLHIMENTO</strong></p>\n<p style="text-align: center;">&nbsp;</p>',
            init: {
                height: 500,
                menubar: false,
                plugins: [
                    "advlist autolink lists link image charmap print preview anchor",
                    "searchreplace visualblocks code fullscreen",
                    "insertdatetime media table paste code help wordcount",
                ],
                toolbar:
                    "undo redo | formatselect | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | help",
            },
        };
    },
    mounted() {
        this.getTermo();

        if (this.item.pessoaReferencia != null) {
            this.pessoaReferencia = this.item.pessoaReferencia;
        }
    },
    computed: {
        todasPessoas() {
            const pessoaPrincipal = {
                id: 'principal',
                nome: this.item.nome_acolhido,
                idade: this.calcularIdade(this.item.nascimento),
                parentesco: 'Acolhido(a)',
                tipo_cadastro: 'Principal',
            };

            const vinculados = this.pessoaReferencia.filter(
                p => p.tipo_cadastro === 'Familiar' || p.tipo_cadastro === 'Crianca'
            );

            return [pessoaPrincipal, ...vinculados];
        },
        isIdoso() {
            const hoje = moment();
            const nascimento = moment(this.item.nascimento, "YYYY-MM-DD");
            const idade = hoje.diff(nascimento, 'years');

            return this.item.solicitacao?.publico_alvo_id === 8 || idade >= 60;
        },
    },
    methods: {
        calcularIdade(dataNasc) {
            if (!dataNasc) return null;
            const hoje = new Date();
            const nasc = new Date(dataNasc);
            let idade = hoje.getFullYear() - nasc.getFullYear();
            const m = hoje.getMonth() - nasc.getMonth();
            if (m < 0 || (m === 0 && hoje.getDate() < nasc.getDate())) {
                idade--;
            }
            return idade;
        },
        changeText(string, pessoa = null) {
            if (string) {


                string = string.replace(
                    `<span id="socioeducando">______________________________________</span>`,
                    `<b>${pessoa?.nome || this.item.nome_acolhido}</b>`
                );
                string = string.replace(
                    `<span id="cidade">São Paulo</span>`,
                    this.app_cidade
                );
                string = string.replace(
                    `<span id="data">_____ de ________________ de 2021</span>`,
                    moment().format("LL")
                );

                // Mostrar ou esconder o bloco do responsável conforme tipo_cadastro
                const tipoCadastro = pessoa?.tipo_cadastro || this.item.tipo_cadastro || '';

                if (tipoCadastro !== 'Crianca') {

                    console.log('Removendo bloco do responsável para tipo:', tipoCadastro);
                    
                    // Usa DOMParser para remover o <p> que contenha o span #responsavel
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(string, 'text/html');
                    const responsavelP = doc.querySelector('p span#responsavel')?.closest('p');
                    if (responsavelP) {
                        responsavelP.remove();
                    }

                    // Remove o bloco do "____________________" + "RESPONSÁVEL"
                    // Procura <p> só com underline e o próximo <p> com texto "RESPONSÁVEL"
                    const ps = doc.querySelectorAll('p');
                    for (let i = 0; i < ps.length - 1; i++) {
                        const currText = ps[i].textContent.trim();
                        const nextText = ps[i + 1].textContent.trim().toUpperCase();
                        if (/^_+$/.test(currText) && nextText === 'RESPONSÁVEL') {
                            ps[i].remove();
                            ps[i + 1].remove();
                            break; // remove só o primeiro bloco encontrado
                        }
                    }

                    string = doc.body.innerHTML;
                }
            }
            this.loading = false;
            return string;
        },
        verificarValueArray(value, array, valueIsArray = false) {
            if (valueIsArray && value) {
                var a = "";
                for (var i = 0; i < value.length; i++) {
                    const result = array.filter(item => item.id == value[i]);
                    a += result[0].value + (i < value.length - 1 ? "," : "");
                }
                return a;
            } else {
                const result = array.filter(item => item.id == value);
                return result[0] ? result[0].value : "";
            }
        },
        selecionarPessoa(pessoa) {

            this.pessoaSelecionada = pessoa;

            if (pessoa.tipo_cadastro === 'Principal') {

                this.caractTermoSelecionada = { ...this.termo.idoso };

            }else{

                const dados = pessoa.termo;
                this.caractTermoSelecionada = dados ? { ...dados } : {
                    pessoa_referencia_id: pessoa.id,
                    texto: this.changeText(this.text_default, pessoa),
                };

            }

        },
        submit() {
            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            if (ladda) ladda.start();

            let texto = document.getElementById("boxContent").innerHTML;

            if (this.pessoaSelecionada) {
                if (this.pessoaSelecionada.tipo_cadastro === 'Principal') {
                    this.termo.idoso = { texto };
                } else {
                    this.pessoaSelecionada.termo = {
                        texto,
                        pessoa_referencia_id: this.pessoaSelecionada.id
                    };
                }
            } else {
                this.termo.idoso = { texto };
            }

            // Prepara o objeto a ser enviado
            const payload = {
                acolhimento_id: this.item.id,
                termo: {
                    idoso: this.termo.idoso,
                    pessoasVinculadas: this.pessoaReferencia
                        .filter(p => p.termo && p.tipo_cadastro !== 'Principal')
                        .map(p => ({
                            ...p.termo,
                            pessoa_referencia_id: p.id,
                        }))
                }
            };

            axios.post(`api/dashboard/acolhimento/idoso/storetermo`, payload)
                .then(() => {
                    this.$snack.success({ text: "Termo salvo com sucesso." });
                })
                .finally(() => {
                    ladda.stop();
                });
        },
        getTermo() {
            this.loading = true;
            axios
                .get(`api/dashboard/acolhimento/idoso/get/termo/${this.item.id}`)
                .then((response) => {
                    
                    this.loading = false;

                    const termo = response.data.termo;

                    if (termo && termo.idoso) {
                        this.termo.idoso = termo.idoso;
                        this.termo.pessoasVinculadas = termo.pessoasVinculadas || [];
                        this.text_edit = this.termo.idoso.texto || "";
                    } else {
                        // Termo não existe ainda ou idoso é null, cria o padrão e atualiza text_edit também
                        const textoDefault = this.changeText(this.text_default, { nome: this.item.nome_acolhido });
                        console.log('Texto default gerado:', textoDefault);
                        this.termo.idoso = { texto: textoDefault };
                        this.text_edit = textoDefault;
                    }

                    // Preenche pessoaReferencia com os dados recebidos
                    this.pessoaReferencia.forEach(p => {
                        const termoPessoa = this.termo.pessoasVinculadas.find(t => t.pessoa_referencia_id === p.id);
                        if (termoPessoa) p.termo = termoPessoa;
                    });

                    if (this.pessoaSelecionada) {
                        if (this.pessoaSelecionada.tipo_cadastro === 'Principal') {
                            return this.termo.idoso?.texto || '';
                        } else {
                            return this.pessoaSelecionada.termo?.texto || '';
                        }
                    } else {
                        return this.termo.idoso?.texto || '';
                    }
                    
                });
        },
        redefinir() {
            const pessoa = this.pessoaSelecionada || { nome: this.item.nome_acolhido };
            const novoTexto = this.changeText(this.text_default, pessoa);

            if (this.pessoaSelecionada) {
                this.caractTermoSelecionada.texto = novoTexto;
            } else {
                this.text_edit = novoTexto;
            }

            document.getElementById("boxContent").innerHTML = novoTexto;
        },
        print() {
            const modal = document.getElementById("boxPrint");
            const cloned = modal.cloneNode(true);
            let section = document.getElementById("print");

            if (!section) {
                section = document.createElement("div");
                section.id = "print";
                document.body.appendChild(section);
            }

            section.innerHTML = "";
            section.appendChild(cloned);
            window.print();
        },
    },
};
</script>
<style lang="css">
.tox-statusbar {
    display: none !important;
}
</style>
